module.exports = __webpack_public_path__ + "img/right-side-menu-layers-active.b5746898.svg";